module.exports = __webpack_public_path__ + "static/max-levchin-42f44176662d02f80fcca4b61ab04b63.jpg";